import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai'

const preAuthAtom = atom<any>(undefined)

export const usePreAuthAtom = () => useAtom(preAuthAtom)

export const usePreAuthAtomValue = () => useAtomValue(preAuthAtom)

export const useSetPreAuthAtom = () => useSetAtom(preAuthAtom)
